import React, { useEffect, useRef } from "react";
import classNames from "classnames/bind";
import ReactPlayer from "react-player";
import { PlayBackContext,TracingEventContext } from "../../../contexts";
import { Close } from "../../../components/Icons/Icons";
import styles from "./Modal.module.css";

import { useStoreContext } from "../../../hooks/useStoreContext";
import { actions } from "../../../store";
import { convertToSeconds } from "../../../utils";

const cx = classNames.bind(styles);
const Modal = ({type = "smart"}) => {
  const { videoFire, url, setIsShow, name, nameService } = React.useContext(type ==="smart" ? PlayBackContext:TracingEventContext)
  // eslint-disable-next-line
  const [dataStore, dispatch] = useStoreContext()
  const refPlayer = useRef(null)
  const handleClose = (e) => {
    const { path, nameCamera, nameNotification, time, cameraCode } = dataStore.pathNotification;
    setIsShow(false)
    let data = {
      path: null,
      nameCamera: nameCamera,
      nameNotification: nameNotification,
      codeCamera: cameraCode,
      time: time
    }
    dispatch(actions.getPathNotification(data))
  }
  useEffect(() => {
    if(refPlayer && nameService === 'Cảnh báo cháy') {
      const timePreEvent = 15;
      const timeStartVideo = convertToSeconds(videoFire.TIME_START_PLAYBACK.split(' ')[1]);
      const timeStartEvent = convertToSeconds(videoFire.TIME_START.split(' ')[1]);
      // tua đến đoạn trước khi có sự kiện (timePreEvent) 15s
      refPlayer.current.seekTo(timeStartEvent - timeStartVideo - timePreEvent, "seconds")
    }
  }, [refPlayer, videoFire])
  return (
    <div className={cx("container")}>
      <div className={cx("content")}>
        <ReactPlayer
          className="react-player"
          url={url}
          width={"100%"}
          height={"100%"}
          playing
          controls
          ref={refPlayer}
        />
        <div className={cx("header")}>
          <div className={cx("name")}>{name}</div>
          <div onClick={handleClose} className={cx("close")}>
            <Close color={"#ffffff"} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
